import React, { useContext } from 'react';
import SwipeSlider from '@wix/da-shared-react/pkg/SwipeSlider';
import { useTranslation } from 'react-i18next';
import { PapiGallection } from '@wix/da-papi-types';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import { MeasuredSlider as Slider } from '@wix/da-shared-react/pkg/Slider';
import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession/selectors';
import WidgetBox, {
  Props as WidgetBoxProps,
} from '../../../../UserWidgets/_partials/WidgetBox';
import { useSelector } from 'react-redux';
import GetCore from '../../_partials/GetCore';
import PremiumFoldersEmptyState from '../../_partials/PremiumFoldersEmptyState';
import ShopFolderThumb from '@wix/da-shared-react/pkg/DeviationViews/Thumb/ShopFolder';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import PremiumFolderCreateButton from '../../_partials/PremiumFolderCreateButton/PremiumFolderCreateButton.connected';

import s from './PremiumFolderSlider.scss';

export interface Props {
  streamId: string;
  moduleId: number;
  folders: PapiGallection[];
  total: number;
  isOwner: boolean;
  username: string;
}

export const PremiumFolderSlider: React.FC<Props & WidgetBoxProps> = ({
  widgetMoveUp,
  widgetMoveDown,
  widgetRemove,
  moduleId,
  folders,
  total,
  username,
  section,
  zone,
  isOwner,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const isEmpty = !folders.length;

  const hasCoreMembership = useSelector(getCurrentUserHasCore);

  // show Add New button to owners only who already have CORE
  const showAddNew = hasCoreMembership && isOwner && !isMobile;
  // show GetCore to owner who doesnt have CORE yet.
  const showGetCore = !hasCoreMembership && isOwner;

  return (
    <WidgetBox
      section={section}
      zone={zone}
      header={t('common.premiumFolders')}
      headerExtras={
        showAddNew ? (
          <PremiumFolderCreateButton className={s['add-new']} />
        ) : showGetCore ? (
          <GetCore />
        ) : undefined
      }
      count={total}
      moduleId={moduleId}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
      isEmpty={isEmpty}
      hasMore={!isEmpty} // until we implement inner slider overflow recognition
      emptyView={<PremiumFoldersEmptyState view={'wide'} />}
      seeAllUrl={Url.userShopPath(
        username,
        USER_PROFILE_SHOP_SUB_PATHS.PREMIUM_FOLDERS
      )}
    >
      {isMobile ? (
        <SwipeSlider>
          {folders.map(folder => (
            <ShopFolderThumb key={folder.folderId} folder={folder} />
          ))}
        </SwipeSlider>
      ) : (
        <>
          <Slider
            renderSliderItems={elementSize =>
              folders.map(folder => (
                <ShopFolderThumb
                  key={folder.folderId}
                  folder={folder}
                  width={elementSize.width}
                />
              ))
            }
          />
        </>
      )}
    </WidgetBox>
  );
};
PremiumFolderSlider.displayName = 'PremiumFolderSlider';

export default PremiumFolderSlider;
